import OnboardingProgressBar from "@/components/Auth/Onboarding/OnboardingProgressBar/OnboardingProgressBar";
import { ChevronLeftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Image from "next/image";

interface OnboardingHeaderProps {
  currentStepKey: string;
  currentStepIndex: number;
  currentVisibleIndex: number;
  totalSteps: number;
  logoUrl: string;
  logoAlt: string;
  onBack: () => void;
  onClose: () => void;
}

/**
 * Header component for the onboarding flow containing navigation controls and progress indicator.
 * Shows logo on welcome step, back button on subsequent steps, progress bar, and close button.
 */
const OnboardingHeader = ({
  currentStepKey,
  currentStepIndex,
  currentVisibleIndex,
  totalSteps,
  logoUrl,
  logoAlt,
  onBack,
  onClose,
}: OnboardingHeaderProps) => {
  return (
    <div
      className={clsx(
        "OnboardingHeader",
        "mb-6 flex shrink-0 items-center justify-between"
      )}
    >
      {/* Left side: back or logo */}
      {currentStepKey === "welcome" && logoUrl ? (
        <Image
          src={logoUrl}
          alt={logoAlt}
          width={150}
          height={60}
          className="h-6 w-auto lg:h-8"
        />
      ) : currentStepIndex > 0 ? (
        <button onClick={onBack}>
          <ChevronLeftIcon className="h-5 w-5" />
        </button>
      ) : (
        <span className="w-5" />
      )}

      {/* Progress bar (if not on welcome step) */}
      {currentStepIndex > 0 && (
        <div className="flex w-full justify-center">
          <div className="w-full max-w-[240px] sm:max-w-[320px]">
            <OnboardingProgressBar
              currentIndex={currentVisibleIndex}
              totalSteps={totalSteps}
            />
          </div>
        </div>
      )}

      {/* Close icon */}
      <button
        onClick={onClose}
        className="flex h-5 w-5 items-center justify-center text-black"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default OnboardingHeader;
